import React, { useEffect } from "react";
import { Grid, Typography, Box, Button } from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import WarningIcon from "@mui/icons-material/Warning";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import StockMovementChart from "./WSStockMovementChart";

import WSCard from "../../Components/WSCard";
import WSdonout from "./WSdonout";
import WSMonthlyStockChart from "./WSMonthlyStockChart";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../FrontEnd/UpdateChange/LableStore";
import { useDashboard } from "../../Context/DashboardContext";
import StockChart from "./WSStockChart";
import LowStockTable from "./Table/LowStockTable";

interface StockMovementChartProps {
  data: Record<string, number> | null;
  loading?: boolean;
}

const StockMovementChart: React.FC<StockMovementChartProps> = ({ data, loading }) => {
  // Convert object to array for recharts
  const chartData = data
    ? Object.entries(data).map(([day, value]) => ({ day, value }))
    : [];

  return <StockChart data={chartData} />;
};

export const DashBoard: React.FC = () => {
  const { data, loading, refresh } = useDashboard();
  console.log('data is',data);

  useEffect(() => {
    updateMainHeader("Inventory");
    labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
    breadCrumbsStore.updateBreadCrumbs([{ Dashboard: "/dashboard" }]);
  }, []);

  return (
    <>
      {}
      <Box
        sx={{
          mb: 4,
          display: "flex",
          flexDirection: "column",
          gap: 1.5, // vertical spacing between items
        }}
      >
        {}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap", // wraps on smaller screens
            mb: 1,
          }}
        >
          <Typography variant="h5" fontWeight={700} sx={{ color: "#111" }}>
            Dashboard Overview
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={refresh}
            sx={{
              ml: { xs: 0, sm: 2 },
              mt: { xs: 1, sm: 0 },
              px: 2,
              py: 0.75,
              fontSize: 14,
              fontWeight: 600,
              textTransform: "none",
              borderRadius: 2,
            }}
          >
            Refresh
          </Button>
        </Box>

        {}
        <Typography
          variant="body2"
          sx={{ color: "#555", lineHeight: 1.6, maxWidth: 600 }}
        >
          A quick summary of your inventory, cheques, and stock movement. Keep track
          of low-stock items, pending cheques, and monthly trends all in one place.
        </Typography>
      </Box>

      {}
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={2.4}>
          <WSCard
            title="Total Items"
            value={`${data?.totalItems ?? 0} Items`} // safe access
            icon={InventoryIcon}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <WSCard
            title="Total Stock Quantity"
            value={`${data?.totalStock ?? 0} Units`}
            icon={InventoryIcon}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <WSCard
            title="Low Stock Items"
            value={`${data?.lowStockItems ?? 0} Units`}
            icon={WarningIcon}
            trendText={`${data?.lowStockItems && data.lowStockItems > 0 ? "-" : "+"}${data?.lowStockItems ? data.lowStockItems : 0}%`}
            trendColor={data?.lowStockItems && data.lowStockItems > 0 ? "red" : "green"}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <WSCard
            title="Pending Cheques"
            value={`${data?.pendingCheques ?? 0}`}
            icon={ReceiptIcon}
            footerText={`AED ${data?.chequeSummary.Pending || 0}`}
            loading={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2.4}>
          <WSCard
            title="Today's Adjustments"
            value={`${data?.todayAdjustments ?? 0}`}
            icon={TrendingUpIcon}
            trendText={`${(data?.todayAdjustments ?? 0) >= 0 ? "+" : ""}${data?.todayAdjustments ?? 0}%`}
            trendColor={(data?.todayAdjustments ?? 0) >= 0 ? "green" : "red"}
            loading={loading}
          />
        </Grid>
      </Grid>

      {}
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={8}>
          <StockMovementChart data={data?.stockMovement ?? null} loading={loading} />
        </Grid>

        <Grid item xs={12} md={4}>
          <WSdonout chequeSummary={data?.chequeSummary ?? null} loading={loading} />
        </Grid>

        <Grid item xs={12} md={5}>
          <WSMonthlyStockChart monthlySummary={data?.monthlySummary ?? null} loading={loading} />
        </Grid>

        <Grid item xs={12} md={7}>
          <LowStockTable data={data?.lowStockList ?? []} loading={loading} />
        </Grid>
      </Grid>
    </>
  );
};